import React from "react";
import { useTranslation } from "react-i18next";
import phoneHandset from "../../assets/icons/phone-handset.png";

/**
 * Figma phone handset asset (stroke outline, #118AB2).
 * Mirrored in RTL so the handset faces the correct direction.
 */
export default function PhoneOutlinedIcon({
  size = 14,
  className = "",
  alt = "",
  style,
  ...rest
}) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  return (
    <img
      {...rest}
      src={phoneHandset}
      width={size}
      height={size}
      alt={alt}
      className={className}
      style={{
        ...style,
        ...(isRtl ? { transform: "scaleX(-1)" } : null),
      }}
      draggable={false}
      aria-hidden={alt ? undefined : true}
    />
  );
}
